import { Controller } from "@hotwired/stimulus";

// Reloads the turbo frame of the Brainpage QR code (my/brainpage_codes/show)
// after the interval, because the token in the code works for 30 seconds only.
// A hidden tab asks for no code. It asks for one when the tab is visible again.
export default class extends Controller {
  static values = { interval: { type: Number, default: 30000 } }

  connect() {
    this.whenVisible = this.whenVisible.bind(this);
    this.timeout = setTimeout(() => this.reload(), this.intervalValue);
  }

  disconnect() {
    clearTimeout(this.timeout);
    document.removeEventListener("visibilitychange", this.whenVisible);
  }

  reload() {
    if (document.hidden) {
      document.addEventListener("visibilitychange", this.whenVisible);
    } else {
      this.element.closest("turbo-frame").reload();
    }
  }

  whenVisible() {
    if (document.hidden) return;

    document.removeEventListener("visibilitychange", this.whenVisible);
    this.element.closest("turbo-frame").reload();
  }
}
